import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getAllSeries = async (params = {}) => {
  const response = await api.get('/series', { params });
  return response.data;
};

export const getSeriesBySlug = async (slug) => {
  const response = await api.get(`/series/${slug}`);
  return response.data;
};

export const getSeriesByType = async (type, page = 1, limit = 10) => {
  const response = await api.get(`/series/type/${type}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getSeriesByCategory = async (categoryId, page = 1, limit = 10) => {
  const response = await api.get(`/series/category/${categoryId}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getFeaturedSeries = async (limit = 5) => {
  const response = await api.get('/series/featured', {
    params: { limit }
  });
  return response.data;
};

export const getPopularSeries = async (limit = 5) => {
  const response = await api.get('/series/popular', {
    params: { limit }
  });
  return response.data;
};

export const getSeriesByTypeAndCategory = async (type, categoryId, page = 1, limit = 10) => {
  const response = await api.get(`/series/type/${type}/category/${categoryId}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getSeriesByLanguage = async (language, page = 1, limit = 10) => {
  const response = await api.get(`/series/language/${language}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getSeriesByLanguageAndType = async (language, type, page = 1, limit = 10) => {
  const response = await api.get(`/series/language/${language}/type/${type}`, {
    params: { page, limit }
  });
  return response.data;
};

export const getSimilarSeries = async (seriesId) => {
  const response = await api.get(`/series/similar/${seriesId}`);
  return response.data;
};

export const getUniqueSeriesByType = async (type, page = 1, limit = 10) => {
  const response = await api.get(`/unique-series/type/${type}`, {
    params: { page, limit }
  });
  return response.data;
};